// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"FallbackPage_fallbackContainer__6ven9","fallbackWrapper":"FallbackPage_fallbackWrapper__BziNf","linksBtn":"FallbackPage_linksBtn__ohL10"};